export const roles = {
	superadmin: 'superadmin',
	admin: 'admin',
	cobroker: 'cobroker',
};
